export interface TopNavDocumentData {
  data: {
    contact_us_title: string
    contactus_description: string
    contact_us_link_text: string
    contact_us_image: string
    contact_us_link: string
  }
}

export const topNavData: TopNavDocumentData = {
  data: {
    contact_us_title: 'FlowID: A 360° Fan Identity',
    contactus_description:
      'Build a unified fan profile that grows across games, seasons, and broadcasts, capturing preferences and history to increase lifetime...',
    contact_us_link_text: 'Explore',
    contact_us_image: '/graphics/locg/marketingHeader.webp',
    contact_us_link: 'https://www.flowcode.com/product/ids-personalization'
  }
}

export interface TopNavSlice {
  primary: {
    header: string
    header_link?: string
  }
  items: {
    link_title: string
    dropdown_link: string
    subsection?: string
  }[]
}

export const TOP_NAV_DESKTOP_LINKS: TopNavSlice[] = [
  {
    primary: {
      header: 'Industry'
    },
    items: [
      {
        link_title: 'Retail & Consumer Goods',
        dropdown_link: 'https://www.flowcode.com/industry/retail-consumer-goods'
      },
      {
        link_title: 'Health & Pharma',
        dropdown_link: 'https://www.flowcode.com/industry/healthcare'
      },
      {
        link_title: 'Sports & Entertainment',
        dropdown_link: 'https://www.flowcode.com/industry/sports-entertainment'
      },
      {
        link_title: 'Financial Services & Insurance',
        dropdown_link: 'https://www.flowcode.com/industry/finance-insurance'
      },
      {
        link_title: 'Media & Agency',
        dropdown_link: 'https://flowcode.com/industry/media-agency'
      },
      {
        link_title: 'Automotive',
        dropdown_link: 'https://www.flowcode.com/industry/auto-manufacturing'
      },
      {
        link_title: 'Travel & Hospitality',
        dropdown_link: 'https://www.flowcode.com/industry/travel-hospitality'
      },
      {
        link_title: 'Tech & Telco',
        dropdown_link: 'https://www.flowcode.com/industry/tech-telco'
      }
    ]
  },
  {
    primary: {
      header: 'Product'
    },
    items: [
      {
        link_title: 'Flowcodes',
        dropdown_link: 'https://www.flowcode.com/product/flowcodes',
        subsection: 'Consumer Touchpoints'
      },
      {
        link_title: 'FlowURLs',
        dropdown_link: 'https://www.flowcode.com/product/flowurls',
        subsection: 'Consumer Touchpoints'
      },
      {
        link_title: 'FlowHubs',
        dropdown_link: 'https://www.flowcode.com/product/flowhubs',
        subsection: 'Consumer Touchpoints'
      },
      {
        link_title: 'FlowID & Personalization',
        dropdown_link: 'https://www.flowcode.com/product/ids-personalization',
        subsection: 'Platform Intelligence'
      },
      {
        link_title: 'Analytics & Integrations',
        dropdown_link: 'https://www.flowcode.com/product/analytics-integrations',
        subsection: 'Platform Intelligence'
      },
      {
        link_title: 'Workspaces & API',
        dropdown_link: 'https://www.flowcode.com/product/workspaces-api',
        subsection: 'Platform Intelligence'
      }
    ]
  },
  {
    primary: {
      header: 'Getting started',
      header_link: 'https://www.flowcode.com/get-started'
    },
    items: []
  },
  {
    primary: {
      header: 'Pricing',
      header_link: 'https://www.flowcode.com/pricing'
    },
    items: []
  }
]
